import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getFollowUpEventsStatus } from "../../api/EmployeeFollowUpEventApi";
import FollowUpEventStatusListForm from "./FollowUpEventStatusListForm";
import "./ManageFollowUpEventStatusListPage.css";
import moment from "moment";
import { Month } from "../common/GeneralConfigurations";

function ManageFollowUpEventStatusListPageBEE() {
  const { t } = useTranslation();
  const [followUpEventsStatusData, setFollowUpEventsStatusData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState(
    moment([moment().year(), 0, 1]).format("MM-DD-yyyy")
  );
  const [endDate, setEndDate] = useState(
    moment([moment().year(), 11, 31]).format("MM-DD-yyyy")
  );

  useEffect(() => {
    onGetFollowUpEventStatus();
  }, [startDate, endDate]);

  const columns = [
    {
      title: t("followUpEventStatusBEE.columns.name"),
      dataIndex: "staffName",
      key: "staffName",
      width: 150,
    },
    {
      title: t("followUpEventStatusBEE.columns.firstYear"),
      children: [
        {
          title: t("followUpEventStatusBEE.events.year1Month1"),
          dataIndex: "year1Month1",
          key: "year1Month1",
          className: "antd-col-title",
          align: "center",
          render: (text, record) => (
            <>
              {record.year1Month1Total !== undefined ? (
                <>
                  {record.year1Month1}/{record.year1Month1Total}
                </>
              ) : (
                <>{record.year1Month1}</>
              )}
            </>
          ),
        },
        {
          title: t("followUpEventStatusBEE.events.year1Month3"),
          dataIndex: "year1Month4",
          key: "year1Month4",
          className: "antd-col-title",
          align: "center",
          render: (text, record) => (
            <>
              {record.year1Month3Total !== undefined ? (
                <>
                  {record.year1Month3}/{record.year1Month3Total}
                </>
              ) : (
                <>{record.year1Month3}</>
              )}
            </>
          ),
        },
        {
          title: t("followUpEventStatusBEE.events.year1Month6"),
          dataIndex: "year1Month6",
          key: "year1Month6",
          className: "antd-col-title",
          align: "center",
          render: (text, record) => (
            <>
              {record.year1Month6Total !== undefined ? (
                <>
                  {record.year1Month6}/{record.year1Month6Total}
                </>
              ) : (
                <>{record.year1Month6}</>
              )}
            </>
          ),
        },
        {
          title: t("followUpEventStatusBEE.events.year1Month9"),
          dataIndex: "year1Month9",
          key: "year1Month9",
          className: "antd-col-title",
          align: "center",
          render: (text, record) => (
            <>
              {record.year1Month9Total !== undefined ? (
                <>
                  {record.year1Month9}/{record.year1Month9Total}
                </>
              ) : (
                <>{record.year1Month9}</>
              )}
            </>
          ),
        },
        {
          title: t("followUpEventStatusBEE.events.year1Month12"),
          dataIndex: "year1Month12",
          key: "year1Month12",
          className: "antd-col-title",
          align: "center",
          render: (text, record) => (
            <>
              {record.year1Month12Total !== undefined ? (
                <>
                  {record.year1Month12}/{record.year1Month12Total}
                </>
              ) : (
                <>{record.year1Month12}</>
              )}
            </>
          ),
        },
      ],
    },
    {
      title: t("followUpEventStatusBEE.columns.nextYears"),
      children: [
        {
          title: t("followUpEventStatusBEE.events.nextYearsMonth3"),
          dataIndex: "nextYearsMonth3",
          key: "nextYearsMonth3",
          className: "antd-col-title",
          align: "center",
          render: (text, record) => (
            <>
              {record.nextYearsMonth3Total !== undefined ? (
                <>
                  {record.nextYearsMonth3}/{record.nextYearsMonth3Total}
                </>
              ) : (
                <>{record.nextYearsMonth3}</>
              )}
            </>
          ),
        },
        {
          title: t("followUpEventStatusBEE.events.nextYearsMonth6"),
          dataIndex: "nextYearsMonth6",
          key: "nextYearsMonth6",
          className: "antd-col-title",
          align: "center",
          render: (text, record) => (
            <>
              {record.nextYearsMonth6Total !== undefined ? (
                <>
                  {record.nextYearsMonth6}/{record.nextYearsMonth6Total}
                </>
              ) : (
                <>{record.nextYearsMonth6}</>
              )}
            </>
          ),
        },
        {
          title: t("followUpEventStatusBEE.events.nextYearsMonth9"),
          dataIndex: "nextYearsMonth9",
          key: "nextYearsMonth9",
          className: "antd-col-title",
          align: "center",
          render: (text, record) => (
            <>
              {record.nextYearsMonth9Total !== undefined ? (
                <>
                  {record.nextYearsMonth9}/{record.nextYearsMonth9Total}
                </>
              ) : (
                <>{record.nextYearsMonth9}</>
              )}
            </>
          ),
        },
        {
          title: t("followUpEventStatusBEE.events.nextYearsMonth12"),
          dataIndex: "nextYearsMonth12",
          key: "nextYearsMonth12",
          className: "antd-col-title",
          align: "center",
          render: (text, record) => (
            <>
              {record.nextYearsMonth12Total !== undefined ? (
                <>
                  {record.nextYearsMonth12}/{record.nextYearsMonth12Total}
                </>
              ) : (
                <>{record.nextYearsMonth12}</>
              )}
            </>
          ),
        },
      ],
    },
    {
      title: t("followUpEventStatusBEE.columns.monthlyPDS"),
      dataIndex: "monthlyPDS",
      key: "monthlyPDS",
      align: "center",
      render: (text, record) => (
        <>
          {record.monthlyPDSTotal !== undefined ? (
            <>
              {record.monthlyPDS}/{record.monthlyPDSTotal}
            </>
          ) : (
            <>{record.monthlyPDS}</>
          )}
        </>
      ),
    },
    {
      title: <strong>{t("followUpEventStatusBEE.columns.total")}</strong>,
      dataIndex: "totalPerRow",
      key: "totalPerRow",
      align: "center",
      render: (text, record) => (
        <>
          {record.totalPerRowTotal !== undefined ? (
            <strong>
              {record.totalPerRow}/{record.totalPerRowTotal}
            </strong>
          ) : (
            <>{record.totalPerRow}</>
          )}
        </>
      ),
    },
  ];

  const onGetFollowUpEventStatus = async () => {
    await getFollowUpEventsStatus(startDate, endDate).then((res) => {
      let finalList = [];
      let final = 0;
      let year1Month1 = 0;
      let year1Month3 = 0;
      let year1Month6 = 0;
      let year1Month9 = 0;
      let year1Month12 = 0;
      let nextYearsMonth3 = 0;
      let nextYearsMonth6 = 0;
      let nextYearsMonth9 = 0;
      let nextYearsMonth12 = 0;
      let finalTotal = 0;
      let year1Month1Total = 0;
      let year1Month3Total = 0;
      let year1Month6Total = 0;
      let year1Month9Total = 0;
      let year1Month12Total = 0;
      let nextYearsMonth3Total = 0;
      let nextYearsMonth6Total = 0;
      let nextYearsMonth9Total = 0;
      let nextYearsMonth12Total = 0;
      let monthlyPDS = 0;
      let monthlyPDSTotal = 0;

      res.data.map((x) => {
        if (x.doneById != null) {
          let found = finalList.find((e) => e.staffName === x.doneByName);
          let findIndex = finalList.findIndex(
            (e) => e.staffName === x.doneByName
          );

          if (found == undefined) {
            let newOne = {
              staffName: x.doneByName,
              year1Month1: 0,
              year1Month3: 0,
              year1Month6: 0,
              year1Month9: 0,
              year1Month12: 0,
              nextYearsMonth3: 0,
              nextYearsMonth6: 0,
              nextYearsMonth9: 0,
              nextYearsMonth12: 0,
              totalPerRow: 0,
              year1Month1Total: 0,
              year1Month3Total: 0,
              year1Month6Total: 0,
              year1Month9Total: 0,
              year1Month12Total: 0,
              nextYearsMonth3Total: 0,
              nextYearsMonth6Total: 0,
              nextYearsMonth9Total: 0,
              nextYearsMonth12Total: 0,
              totalPerRowTotal: 0,
              monthlyPDS: 0,
              monthlyPDSTotal: 0,
            };

            if (x.eventTypeId >= 20 && x.eventTypeId <= 33) {
              newOne.monthlyPDS = x.countDone;
              monthlyPDS += newOne.monthlyPDS;
              newOne.monthlyPDSTotal = x.countDone + x.countUndone;
              monthlyPDSTotal += newOne.monthlyPDSTotal;
            }

            if (x.isFirstYear) {
              switch (x.month) {
                case Month.One:
                  newOne.year1Month1 = x.countDone;
                  year1Month1 += newOne.year1Month1;
                  newOne.year1Month1Total = x.countDone + x.countUndone;
                  year1Month1Total += newOne.year1Month1Total;
                  break;
                case Month.Three:
                  newOne.year1Month3 = x.countDone;
                  year1Month3 += newOne.year1Month3;
                  newOne.year1Month3Total = x.countDone + x.countUndone;
                  year1Month3Total += newOne.year1Month3Total;
                  break;
                case Month.Six:
                  newOne.year1Month6 = x.countDone;
                  year1Month6 += newOne.year1Month6;
                  newOne.year1Month6Total = x.countDone + x.countUndone;
                  year1Month6Total += newOne.year1Month6Total;
                  break;
                case Month.Nine:
                  newOne.year1Month9 = x.countDone;
                  year1Month9 += newOne.year1Month9;
                  newOne.year1Month9Total = x.countDone + x.countUndone;
                  year1Month9Total += newOne.year1Month9Total;
                  break;
                case Month.Twelve:
                  newOne.year1Month12 = x.countDone;
                  year1Month12 += newOne.year1Month12;
                  newOne.year1Month12Total = x.countDone + x.countUndone;
                  year1Month12Total += newOne.year1Month12Total;
                  break;
              }
            } else {
              switch (x.month) {
                case Month.Three:
                  newOne.nextYearsMonth3 = x.countDone;
                  nextYearsMonth3 += newOne.nextYearsMonth3;
                  newOne.nextYearsMonth3Total = x.countDone + x.countUndone;
                  nextYearsMonth3Total += newOne.nextYearsMonth3Total;
                  break;
                case Month.Six:
                  newOne.nextYearsMonth6 = x.countDone;
                  nextYearsMonth6 += newOne.nextYearsMonth6;
                  newOne.nextYearsMonth6Total = x.countDone + x.countUndone;
                  nextYearsMonth6Total += newOne.nextYearsMonth6Total;
                  break;
                case Month.Nine:
                  newOne.nextYearsMonth9 = x.countDone;
                  nextYearsMonth9 += newOne.nextYearsMonth9;
                  newOne.nextYearsMonth9Total = x.countDone + x.countUndone;
                  nextYearsMonth9Total += newOne.nextYearsMonth9Total;
                  break;
                case Month.Twelve:
                  newOne.nextYearsMonth12 = x.countDone;
                  nextYearsMonth12 += newOne.nextYearsMonth12;
                  newOne.nextYearsMonth12Total = x.countDone + x.countUndone;
                  nextYearsMonth12Total += newOne.nextYearsMonth12Total;
                  break;
              }
            }

            let totalPerRow = 0;
            totalPerRow =
              newOne.year1Month1 +
              newOne.year1Month3 +
              newOne.year1Month6 +
              newOne.year1Month9 +
              newOne.year1Month12 +
              newOne.nextYearsMonth3 +
              newOne.nextYearsMonth6 +
              newOne.nextYearsMonth9 +
              newOne.nextYearsMonth12;
            newOne.totalPerRow = totalPerRow;

            let totalPerRowTotal = 0;
            totalPerRowTotal =
              newOne.year1Month1Total +
              newOne.year1Month3Total +
              newOne.year1Month6Total +
              newOne.year1Month9Total +
              newOne.year1Month12Total +
              newOne.nextYearsMonth3Total +
              newOne.nextYearsMonth6Total +
              newOne.nextYearsMonth9Total +
              newOne.nextYearsMonth12Total;
            newOne.totalPerRowTotal = totalPerRowTotal;

            final =
              year1Month1 +
              year1Month3 +
              year1Month6 +
              year1Month9 +
              year1Month12 +
              nextYearsMonth3 +
              nextYearsMonth6 +
              nextYearsMonth9 +
              nextYearsMonth12;

            finalTotal =
              year1Month1Total +
              year1Month3Total +
              year1Month6Total +
              year1Month9Total +
              year1Month12Total +
              nextYearsMonth3Total +
              nextYearsMonth6Total +
              nextYearsMonth9Total +
              nextYearsMonth12Total;

            finalList.push(newOne);
          } else {
            if (x.eventTypeId >= 20 && x.eventTypeId <= 33) {
              finalList[findIndex].monthlyPDS += x.countDone;
              monthlyPDS += x.countDone;
              finalList[findIndex].monthlyPDSTotal +=
                x.countDone + x.countUndone;
              monthlyPDSTotal += x.countDone + x.countUndone;
            }

            if (x.isFirstYear) {
              switch (x.month) {
                case Month.Two:
                  finalList[findIndex].year1Month1 += x.countDone;
                  year1Month1 += x.countDone;
                  finalList[findIndex].year1Month1Total +=
                    x.countDone + x.countUndone;
                  year1Month1Total += x.countDone + x.countUndone;
                  break;
                case Month.Three:
                  finalList[findIndex].year1Month3 += x.countDone;
                  year1Month3 += x.countDone;
                  finalList[findIndex].year1Month3Total +=
                    x.countDone + x.countUndone;
                  year1Month3Total += x.countDone + x.countUndone;
                  break;
                case Month.Six:
                  finalList[findIndex].year1Month6 += x.countDone;
                  year1Month6 += x.countDone;
                  finalList[findIndex].year1Month6Total +=
                    x.countDone + x.countUndone;
                  year1Month6Total += x.countDone + x.countUndone;
                  break;
                case Month.Nine:
                  finalList[findIndex].year1Month9 += x.countDone;
                  year1Month9 += x.countDone;
                  finalList[findIndex].year1Month9Total +=
                    x.countDone + x.countUndone;
                  year1Month9Total += x.countDone + x.countUndone;
                  break;
                case Month.Twelve:
                  finalList[findIndex].year1Month12 += x.countDone;
                  year1Month12 += x.countDone;
                  finalList[findIndex].year1Month12Total +=
                    x.countDone + x.countUndone;
                  year1Month12Total += x.countDone + x.countUndone;
                  break;
              }
            } else {
              switch (x.month) {
                case Month.Three:
                  finalList[findIndex].nextYearsMonth3 += x.countDone;
                  nextYearsMonth3 += x.countDone;
                  finalList[findIndex].nextYearsMonth3Total +=
                    x.countDone + x.countUndone;
                  nextYearsMonth3Total += x.countDone + x.countUndone;
                  break;
                case Month.Six:
                  finalList[findIndex].nextYearsMonth6 += x.countDone;
                  nextYearsMonth6 += x.countDone;
                  finalList[findIndex].nextYearsMonth6Total +=
                    x.countDone + x.countUndone;
                  nextYearsMonth6Total += x.countDone + x.countUndone;
                  break;
                case Month.Nine:
                  finalList[findIndex].nextYearsMonth9 += x.countDone;
                  nextYearsMonth9 += x.countDone;
                  finalList[findIndex].nextYearsMonth9Total +=
                    x.countDone + x.countUndone;
                  nextYearsMonth9Total += x.countDone + x.countUndone;
                  break;
                case Month.Twelve:
                  finalList[findIndex].nextYearsMonth12 += x.countDone;
                  nextYearsMonth12 += x.countDone;
                  finalList[findIndex].nextYearsMonth12Total +=
                    x.countDone + x.countUndone;
                  nextYearsMonth12Total += x.countDone + x.countUndone;
                  break;
              }
            }

            let totalPerRow = 0;
            totalPerRow =
              finalList[findIndex].year1Month1 +
              finalList[findIndex].year1Month3 +
              finalList[findIndex].year1Month6 +
              finalList[findIndex].year1Month9 +
              finalList[findIndex].year1Month12 +
              finalList[findIndex].nextYearsMonth3 +
              finalList[findIndex].nextYearsMonth6 +
              finalList[findIndex].nextYearsMonth9 +
              finalList[findIndex].nextYearsMonth12 +
              finalList[findIndex].monthlyPDS;
            finalList[findIndex].totalPerRow = <>{totalPerRow}</>;

            let totalPerRowTotal = 0;
            totalPerRowTotal =
              finalList[findIndex].year1Month1Total +
              finalList[findIndex].year1Month3Total +
              finalList[findIndex].year1Month6Total +
              finalList[findIndex].year1Month9Total +
              finalList[findIndex].year1Month12Total +
              finalList[findIndex].nextYearsMonth3Total +
              finalList[findIndex].nextYearsMonth6Total +
              finalList[findIndex].nextYearsMonth9Total +
              finalList[findIndex].nextYearsMonth12Total +
              finalList[findIndex].monthlyPDSTotal;
            finalList[findIndex].totalPerRowTotal = <>{totalPerRowTotal}</>;

            final =
              year1Month1 +
              year1Month3 +
              year1Month6 +
              year1Month9 +
              year1Month12 +
              nextYearsMonth3 +
              nextYearsMonth6 +
              nextYearsMonth9 +
              nextYearsMonth12 +
              monthlyPDS;

            finalTotal =
              year1Month1Total +
              year1Month3Total +
              year1Month6Total +
              year1Month9Total +
              year1Month12Total +
              nextYearsMonth3Total +
              nextYearsMonth6Total +
              nextYearsMonth9Total +
              nextYearsMonth12Total +
              monthlyPDSTotal;
          }
        }
      });

      let total = {
        staffName: <strong>{t("followUpEventStatusBEE.columns.total")}</strong>,
        year1Month1: <strong>{`${year1Month1}/${year1Month1Total}`}</strong>,
        year1Month3: <strong>{`${year1Month3}/${year1Month3Total}`}</strong>,
        year1Month6: <strong>{`${year1Month6}/${year1Month6Total}`}</strong>,
        year1Month9: <strong>{`${year1Month9}/${year1Month9Total}`}</strong>,
        year1Month12: <strong>{`${year1Month12}/${year1Month12Total}`}</strong>,
        nextYearsMonth3: (
          <strong>{`${nextYearsMonth3}/${nextYearsMonth3Total}`}</strong>
        ),
        nextYearsMonth6: (
          <strong>{`${nextYearsMonth6}/${nextYearsMonth6Total}`}</strong>
        ),
        nextYearsMonth9: (
          <strong>{`${nextYearsMonth9}/${nextYearsMonth9Total}`}</strong>
        ),
        nextYearsMonth12: (
          <strong>{`${nextYearsMonth12}/${nextYearsMonth12Total}`}</strong>
        ),
        monthlyPDS: <strong>{`${monthlyPDS}/${monthlyPDSTotal}`}</strong>,
        totalPerRow: <strong>{`${final}/${finalTotal}`}</strong>,
      };

      finalList.push(total);
      setFollowUpEventsStatusData(finalList);
      setLoading(false);
    });
  };

  const onSelectDateRange = (value) => {
    if (value) {
      setStartDate(moment(value[0]).startOf("M").format("MM-DD-yyyy"));
      setEndDate(moment(value[1]).endOf("M").format("MM-DD-yyyy"));
    } else {
      setStartDate([]);
      setEndDate([]);
    }
  };

  return (
    <FollowUpEventStatusListForm
      columns={columns}
      followUpEventsStatusData={followUpEventsStatusData}
      loading={loading}
      onSelectDateRange={onSelectDateRange}
      startDate={startDate}
      endDate={endDate}
    />
  );
}

export default ManageFollowUpEventStatusListPageBEE;
